import React from 'react';
import { connect } from 'react-redux';
import TablaComprobantes from '../TablaComprobantes/TablaComprobantes';
import * as actions from "../../../../store/actions";

const TablaPedidosPendientes = (props) => {
  const {
    comprobantes,
    loading,
    estaCargado,
  } = props;

  const data = () => {
    let listaComprobantes = estaCargado ? comprobantes : [];

    return listaComprobantes && listaComprobantes.map((comprobante) => {
      return {
        fecha: comprobante.fecha,
        comprobante: comprobante.comprobante,
        referencia: comprobante.referencia,
        numeroExterno: comprobante.numeroExterno,
        monto: comprobante.monto && comprobante.monto.toFixed(2),
        idComproba: comprobante.idComproba,
        idSistema: comprobante.idSistema,
        idSucursal: comprobante.idSucursal,
        proveedorNombre: comprobante.proveedorNombre,
        proveedorCodigo: comprobante.proveedorCodigo,
        montoPendiente: comprobante.montoPendiente && comprobante.montoPendiente.toFixed(2),
        gasto: comprobante.gasto ?? false,
      };
    });
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }} >
      <TablaComprobantes 
        data={data()} 
        loading={loading} 
        minHeight='300px'
        maxHeight='380px'
        onFiltersClick={() => props.onShowFiltersModal()}
        tituloTabla={"Órdenes de compra pendientes" }
      />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    comprobantes: state.compras.comprobantesOrdenesDeComprasPendientes.comprobantes,
    loading: state.compras.comprobantesOrdenesDeComprasPendientes.loading,
    estaCargado: state.compras.comprobantesOrdenesDeComprasPendientes.estaCargado,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onShowFiltersModal: () => dispatch(actions.showListFiltersModal(true, 'Pedidos pendientes', ['pedido']))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TablaPedidosPendientes);